// src/data/exercises/L4_05.js

const accountOptions = [
  '現金', '当座預金', '仮受金', '使途不明金', '仮払金'];

export const L4_05 = {
  title: '簿記　3級（第212-5回）',
  questions: [
    {
      id: 'q1',
      type: 'JOURNAL_ENTRY',
      content: {
    parts: [
    { "type": "ruby", "text": "出張中", "ruby": "しゅっちょうちゅう" },
    { "type": "text", "value": "の" },
    { "type": "ruby", "text": "従業員", "ruby": "じゅうぎょういん" },
    { "type": "text", "value": "から" },
    { "type": "ruby", "text": "当座預金口座", "ruby": "とうざよきんこうざ" },
    { "type": "text", "value": "へ￥20,000の" },
    { "type": "ruby", "text": "振込", "ruby": "ふりこみ" },
    { "type": "text", "value": "みがあったが、その" },
    { "type": "ruby", "text": "内容", "ruby": "ないよう" },
    { "type": "text", "value": "が" },
    { "type": "ruby", "text": "不明", "ruby": "ふめい" },
    { "type": "text", "value": "であった。" }
],
      },
      table: {
        options: accountOptions,
      },
      answer: [
        { debitAccount: '当座預金', debitAmount: 20000, creditAccount: '仮受金', creditAmount: 20000},
      ],

      // Giải thích chi tiết khi trả lời ĐÚNG (có định dạng)
      explanation_correct: {
        parts: [
          { type: 'text', value: '①まず、当座預金に振り込みがあったので\n' },
          { type: 'text', value: '当座預金が増加（プラス）します。\n' },
          { type: 'styled', value: '当座預金の増加（プラス）は借方（左・Ｄｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: '②次に、内容が不明（わからない）ので\n' },
          { type: 'text', value: '仮受金が増加（プラス）します。\n' },
          { type: 'styled', value: '仮受金の増加（プラス）は貸方（右・Ｃｒ）に記入します。', color: 'red', bold: true },
        ]
      },

      // Gợi ý 2 cấp độ khi trả lời SAI
      hints: {
        account: [
          // Gợi ý lần 1, 2
`①まず、当座預金に振り込みがあったので
当座預金が増加（プラス）します。

②次に、内容が不明（わからない）ので
仮受金が増加（プラス）します。


`,
          // Gợi ý lần 3 (chi tiết hơn, có định dạng)
          {
           parts: [
          { type: 'text', value: '①まず、当座預金に振り込みがあったので\n' },
          { type: 'text', value: '当座預金が増加（プラス）します。\n' },
          { type: 'styled', value: '当座預金の増加（プラス）は借方（左・Ｄｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: '②次に、内容が不明（わからない）ので\n' },
          { type: 'text', value: '仮受金が増加（プラス）します。\n' },
          { type: 'styled', value: '仮受金の増加（プラス）は貸方（右・Ｃｒ）に記入します。', color: 'red', bold: true },
        ]
          }
        ],
       
        
      },
    },
  ],
};